import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import { Button } from 'react-bootstrap';

class BrandManagerHome extends React.Component {

  render() {
    return (

      <div className="container-fluid">
        <div className="row landing-center">
          <div className="col-sm-12">
            <h1>Welcome to Catch!</h1>
            <h3>Catch allows you to find more business for your hotel properties.</h3>
            <h3>Check for <Link to="/booking">booking requests</Link> from Travel Agencies</h3>
          </div>
          <hr />
          <div className="col-sm-12 landing-buttons">
              <Link to="/booking">
                <Button className="btn btn-lg btn-success">
                  Booking Requests
                </Button>
              </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default BrandManagerHome;



// WEBPACK FOOTER //
// src/routes/home/components/BrandManagerHome.js